// extracted by mini-css-extract-plugin
export default {"tableContainer":"Budget_tableContainer__csyur","table":"Budget_table__4rPLY","transactionsOnBudgetContainer":"Budget_transactionsOnBudgetContainer__mCpxS"};